import { SkeletonLoadingViewProps } from "./SkeletonLoadingView.types"
import "./SkeletonLoadingView.css"

const SkeletonLoadingView = (props: SkeletonLoadingViewProps) => {

  const { style } = props
  return (
    <div className="skeleton-text-line" style={style} />
  )
}

export default SkeletonLoadingView